import { Link } from 'react-router-dom';
import { Sparkles, Plus } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

export default function CreditsBalance({ className = '' }) {
  const { user, credits, promo } = useAuth();
  if (!user) return null;

  // During promo, show "FREE" pill instead of credit count
  if (promo?.active) {
    return (
      <Link
        to="/ask"
        className={`group inline-flex items-center gap-1.5 rounded-full border border-rose-tint bg-rose-tint/60 hover:bg-rose-tint transition-colors px-2.5 py-1 ${className}`}
        data-testid="nav-credits-pill"
        aria-label="AI features are free during launch promo"
        title="All AI features are free during launch"
      >
        <Sparkles className="h-3.5 w-3.5 text-rose-gold" />
        <span className="text-xs font-semibold text-ink uppercase tracking-[0.14em]">
          Free
        </span>
        <span className="hidden sm:inline text-[10px] uppercase tracking-[0.18em] text-foreground/70">
          AI access
        </span>
      </Link>
    );
  }

  return (
    <Link
      to="/credits"
      className={`group inline-flex items-center gap-1.5 rounded-full border border-rose-tint bg-accent/40 hover:bg-accent transition-colors px-2.5 py-1 ${className}`}
      data-testid="nav-credits-pill"
      aria-label={`You have ${credits} credits. Buy more.`}
      title="Credits — click to buy more"
    >
      <Sparkles className="h-3.5 w-3.5 text-rose-gold" />
      <span className="text-xs font-semibold tabular-nums text-ink" data-testid="credits-balance-value">
        {credits}
      </span>
      <span className="hidden sm:inline text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
        credits
      </span>
      <span className="hidden md:inline-flex items-center justify-center h-4 w-4 rounded-full bg-rose-gold/10 text-rose-gold opacity-0 group-hover:opacity-100 transition-opacity">
        <Plus className="h-3 w-3" />
      </span>
    </Link>
  );
}
